export interface Transaction {
  id: number;
  user_id: number;
  transaction_type: TransactionTypeEnum;
  amount: string;
  description: string;
  event_id: number | null;
  order_id: number | null;
  sale_id: number | null;
  created_at: string;
  updated_at: string;
}

export type PaymentChannel = "pdv_portaria" | "pdv_seller" | "online";

export enum TransactionTypeEnum {
  VENDA = "sale",
  SAQUE = "withdrawal",
  EXTORNO = "refund",
  MULTA_CANCELAMENTO = "cancellation_fine",
  PDV_RECEIVED = "pdv_received",
  PDV_FEE = "pdv_fee",
  PDV_REFUND = "pdv_refund",
  PDV_FEE_REVERSAL = "pdv_fee_reversal",
  PDV_FEE_DEBIT = "pdv_fee_debit",
  PDV_FEE_DEBIT_REVERSAL = "pdv_fee_debit_reversal",
  TAXA_PDV = "pdv_fee_debit",
  RECEBIDO_PDV = "pdv_received",
}

export interface StatementFilters {
  startDate?: Date | null;
  endDate?: Date | null;
  eventId?: number | null;
  paymentMethod?: string | null;
  paymentChannel?: PaymentChannel | null;
  direction?: string | null;
}
